import React from "react";
import "./header.css";

function Header() {
  return <header className="header" />;
}

export default Header;
